// lib/usePuckBatchData.ts
import type { SiteId } from "@/sites/config"
import { useEffect, useState } from "react"
import type { BatchDataMap } from "./batch-data-context"
import { extractBatchRequests } from "./extract-batch-requests"
import { fetchBatchData } from "./fetch-batch-data"

export function usePuckBatchData(
  puckData: any,
  options: { locale?: string; siteId?: SiteId } = {}
) {
  const [batchData, setBatchData] = useState<BatchDataMap>({})
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!puckData) return

    const requests = extractBatchRequests(puckData, options)
    if (requests.length === 0) return

    setLoading(true)
    fetchBatchData(requests)
      .then(setBatchData)
      .finally(() => setLoading(false))
  }, [puckData, options.locale, options.siteId])

  return { batchData, loading }
}
